import { showToast } from '@shared/components';
import { TOAST_TYPES, sessionExpireMsg } from '@shared/constants';
import { getRCRedirectUri } from '@utils';

let alreadyRedirected = false;

const redirectToLogin = () => {
  if (alreadyRedirected) return;
  alreadyRedirected = true;

  window.location.replace(getRCRedirectUri());
};

export default async (
  api,
  defaultMsg = 'Something went wrong, please contact your system administrator.'
) => {
  try {
    const { data: response, status, ...request } = await api;

    if (status === 202 && response.error) {
      throw response;
    }

    if (
      request.request.responseType === 'blob' ||
      request.headers['content-type'] === 'application/zip'
    ) {
      return {
        data: response,
        message: response.message,
        error: null,
      };
    }

    return {
      data: response && response.data,
      message: response.message,
      error: null,
    };
  } catch (err) {
    let accessDeniedError = '';
    if (!err.response) {
      console.log(
        'IS NETWORK ERROR',
        err.message && err.message.toLowerCase().indexOf('network error') === -1
      );
      return {
        data: null,
        status: null,
        error:
          err.message &&
          err.message.toLowerCase().indexOf('network error') === -1
            ? err.message || err.error || defaultMsg
            : [{ message: '' }],
      };
    }
    if (
      err &&
      err.response &&
      err.response.status === 401 &&
      err.response?.data?.error?.toLowerCase() !== 'under maintenance'
    ) {
      accessDeniedError = sessionExpireMsg;
      redirectToLogin();
    }

    return {
      data: null,
      status:
        err && err.response && err.response.status ? err.response.status : null,
      error:
        (err.response && err.response.data.error) ||
        accessDeniedError ||
        defaultMsg,
    };
  }
};

export const rcApiResponseFormatter = async (
  api,
  defaultMsg = 'Something went wrong, please contact your system administrator.'
) => {
  try {
    const response = await api;
    if (response.request.responseType === 'arraybuffer') {
      return response;
    }

    // To Do: Add response type "array" check
    if (!response.data.hasOwnProperty('records')) {
      const { data } = response;
      return {
        data,
        error: data.errors,
      };
    }

    const {
      data: { records, errors, token, navigation },
    } = response;

    let formattedResponse = {
      data: records,
      paging: response.data.paging,
      error: errors,
    };

    if (token) formattedResponse.token = token;
    if (navigation) formattedResponse.navigation = navigation;

    return formattedResponse;
  } catch (err) {
    let customErrorMsg = '';
    if (!err.response) {
      return {
        data: null,
        status: null,
        error: err.message || defaultMsg,
      };
    }
    if (
      err &&
      err.response &&
      err.response.status === 401 &&
      err.origin !== 'JWKS'
    ) {
      customErrorMsg = sessionExpireMsg;
      showToast(sessionExpireMsg, TOAST_TYPES.ERROR);
      redirectToLogin();

      return {
        data: null,
        error: customErrorMsg,
      };
    } else if (err && err.response && err.response.status === 429) {
      customErrorMsg =
        'RC Api: Too many requests, please contact system administrator';
      showToast(customErrorMsg, TOAST_TYPES.ERROR);
    } else if (
      err.response.data &&
      Array.isArray(err.response.data.errors) &&
      err.response.data.errors.length > 0
    ) {
      if (typeof err.response.data.errors[0] === 'string') {
        err.response.data.error = err.response.data.errors[0];
        delete err.response.data.errors;
      } else {
        err.response.data.errors[0].message = `RC Api: ${err.response.data
          .errors[0].message || defaultMsg}`;
      }
    }

    return {
      data: null,
      status:
        err && err.response && err.response.status ? err.response.status : null,
      error: Array.isArray(err.response.data.errors)
        ? err.response.data.errors
        : `RC Api: ${(err.response && err.response.data.error) ||
            err.response.data.message ||
            defaultMsg}`,
    };
  }
};
